import FeatureGates from '@atlaskit/feature-gate-js-client';
import { fg } from '@atlaskit/platform-feature-flags';

/**
 * Whether the "use Rovo config store" migration is enabled for the current
 * session.
 *
 * The legacy feature gate `rovo_cas_use_rovo_config` takes precedence: when it
 * is `true` this returns `true` immediately. When the gate is `false` we fall
 * back to the `rovo_cas_use_rovo_config_exp` experiment (the `cohort` param,
 * where the `test` cohort opts in).
 *
 * Gate: https://switcheroo.atlassian.com/ui/gates/702d65fa-af17-413f-9e30-012a792c989f/key/rovo_cas_use_rovo_config
 */
export const isUsingRovoConfigStoreExperiment = (): boolean => {
	if (fg('rovo_cas_use_rovo_config')) {
		return true;
	}
	return (
		FeatureGates.getExperimentValue<string>('rovo_cas_use_rovo_config_exp', 'cohort', 'control') ===
		'test'
	);
};

// Experiment: https://switcheroo.atlassian.com/ui/gates/ca4413ca-ac7e-4b41-a744-cd86b29d783c/key/afm_customer_contact_search_type_experiment
export const serveCustomerContactEntityType: () => boolean = (): boolean => {
	return (
		FeatureGates.getExperimentValue<string>(
			'afm_customer_contact_search_type_experiment',
			'cohort',
			'control',
		) === 'test'
	);
};
